import { render, staticRenderFns } from "./StoreDetailsMainCardComponent.vue?vue&type=template&id=78f37f64"
import script from "./StoreDetailsMainCardComponent.vue?vue&type=script&lang=ts"
export * from "./StoreDetailsMainCardComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports